import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '../../core/services/auth.service';
import { AuthfakeauthenticationService } from '../../core/services/authfake.service';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { AccessSessionStorage } from 'src/app/core/services/vs-services/session-storage.service';
import { UserDetails } from "src/app/core/models/vs-models/user-details.model";
import { requestType } from 'src/app/core/models/vs-models/api-service-options.model';
import { ApiEndpoints } from 'src/app/core/models/vs-models/all-urls.model';
import { ApiHandlingService } from 'src/app/core/services/vs-services/api-handler.service';
@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})

/**
 * Topbar component
 */
export class TopbarComponent implements OnInit {
  data:any = [];
  element;
  cookieValue;
  flagvalue;
  countryName;
  valueset;
  isAdmin:boolean=false;
  userDetails: UserDetails = JSON.parse(this.sessionStorage.getLoginSessionData('userDetails'));
  userName=this.userDetails.userName;
  email = this.userDetails.email;
  cmpnyClr = this.userDetails.cmpnyClr;
  constructor(@Inject(DOCUMENT) private document: any, private router: Router, private authService: AuthenticationService,
              private authFackservice: AuthfakeauthenticationService,
              public languageService: LanguageService,
              private apiHandle: ApiHandlingService,
              public translate: TranslateService,
              public _cookiesService: CookieService,
              private sessionStorage: AccessSessionStorage) {
  }

  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
    { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' },
    { text: 'Italian', flag: 'assets/images/flags/italy.jpg', lang: 'it' },
    { text: 'Russian', flag: 'assets/images/flags/russia.jpg', lang: 'ru' },
  ];

  openMobileMenu: boolean;

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  ngOnInit() {
    this.isAdmin=this.userDetails.admin;
    this.openMobileMenu = false;
    this.element = document.documentElement;
    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.jpg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }

  }

  navigateToNotifs(id){
    let str:string = '/dashboard/notification/viewAll/'+id;
    console.log('Navigating to notification:', str);
    this.router.navigate([str]);
  }

    setLanguage(text: string, lang: string, flag: string) {
      this.countryName = text;
      this.flagvalue = flag;
      this.cookieValue = lang;
      this.languageService.setLanguage(lang);
    }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  logout() {
    this.sessionStorage.removeAllSessions();
    window.sessionStorage.removeItem('userDetails');
    this.router.navigate(['/account/login']);
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }
  loadNotifs(){
    this.data=[];
    console.log('Loading notifications for email:', this.email);
    this.apiHandle.getReq(
      requestType.METHOD_GET_PARAMS, ApiEndpoints.GET_NOTIF_DATA,{email:this.email,pageNum:0,pageSize:10,sortCol:'nftDataId',sortOrd:'desc'}).subscribe(
        (renderFD: any) => {
          try{
            console.log('Notification API response:', renderFD);
            // Handle different response structures
            if (renderFD && Array.isArray(renderFD)) {
              this.data = renderFD;
            } else if (renderFD && renderFD.content && Array.isArray(renderFD.content)) {
              this.data = renderFD.content;
            } else {
              this.data = [];
            }
            console.log('Processed notification data:', this.data);
          }catch(error){
            console.error('Error processing notifications:', error);
            this.data = [];
          }
        },
        (error) => {
          console.error('Error loading notifications:', error);
          this.data = [];
        })
  }

  timesAgo(value: string): string {
    // Check if value is valid
    if (!value || value === 'undefined' || value === 'null' || value === '') {
      return 'Unknown time';
    }

    const time = new Date(value);

    // Check if the date is valid
    if (isNaN(time.getTime())) {
      return 'Invalid date';
    }

    const now = new Date();
    const seconds = Math.floor((now.getTime() - time.getTime()) / 1000);

    // Handle future dates
    if (seconds < 0) {
      return this.formatDateTime(time);
    }

    if (seconds < 60) {
      return 'just now';
    } else if (seconds < 120) {
      return 'a minute ago';
    } else if (seconds < 3600) {
      return Math.floor(seconds / 60) + ' minutes ago';
    } else if (seconds < 7200) {
      return 'an hour ago';
    } else if (seconds < 86400) {
      return Math.floor(seconds / 3600) + ' hours ago';
    } else {
      return this.formatDateTime(time);
    }
  }

  formatDateTime(dateTimeString) {
    // Check if value is valid
    if (!dateTimeString || dateTimeString === 'undefined' || dateTimeString === 'null' || dateTimeString === '') {
      return 'Unknown time';
    }

    // Create a new Date object from the datetime string
    const date = new Date(dateTimeString);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return 'Invalid date';
    }

    // Define an array of month names
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // Get day, month, year, hours, and minutes from the Date object
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // Format the date and time as 'DD MMM YYYY at HH:MM'
    return `${day} ${month} ${year} at ${hours}:${minutes}`;
  }
}
